import firebase from 'firebase';
import {updatealerts} from '@/functions.js';

export default{

    mutations: {
        setShares(state, payload) {
            this.state.shares = payload;
            updatealerts();
        },
        addShare(state, payload) {
            //alert('addShare');
            this.state.shares.push(payload);
            updatealerts();
        },
        cutShare(state,payload){
            const deleted = this.state.shares.find(share => share.ID === payload);
            const index = this.state.shares.indexOf(deleted);
            this.state.shares.splice(index, 1);
            updatealerts();
        },
        changedShare(state,payload){
            //alert('check changedShare');
            var changed= this.state.shares.find(share => share.ID === payload.ID);
            var isselected = changed.IsSelected;
            changed.val = payload.val;
            changed.IsSelected = isselected; 
            updatealerts();
        },
    },
    actions:{
        addShare(state, share) {
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/myshares').push(share);
        },
        cutShare(state, share) {
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/myshares/' + share.ID).remove();
        },
        setShare(state, share) {
            var sid = share.ID;
            var dat = { ...share };
            delete (dat.ID);
            delete (dat.IsSelected);
            delete (dat.val);
            if (dat.Survey == null)
                delete (dat.Survey);
            if ((dat.Contacts == null) || ((dat.Contacts != null) && (dat.Contacts.length == 0)))
                delete (dat.Contacts);
            if ((dat.Groups == null) || ((dat.Groups != null) && (dat.Groups.length == 0)))
                delete (dat.Groups);
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/myshares/' + sid).set(dat);
        }
    }
}